import axios from "axios";

const service = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
  // Batasi waktu tunggu request supaya spinner tidak menggantung tanpa batas
  // saat backend lambat (mis. pool DB penuh). Upload file diberi timeout lebih
  // longgar lewat per-request config di pemanggilnya.
  timeout: 30000,
});

service.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  return config;
});

export default service;
